import React from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { FORM_FIELD } from '../../../ui/formTheme';

const EvaluationSelect = ({ label, name, options = [], placeholder = "Select...", className = "", inputClassName = "", labelClassName = FORM_FIELD.label, disabled = false, isRequired = false, rules, reserveErrorSpace = false, errorClassName = FORM_FIELD.errorText, children, ...props }) => {
    const { register, watch, formState: { errors } } = useFormContext();
    const value = watch(name);
    const { onChange, onBlur, name: fieldName, ref } = register(name, rules);

    // Helper to get nested error
    const getNestedError = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    const error = getNestedError(errors, name);
    const errorMessage = error?.message;

    return (
        <div className={`${className} min-w-0 max-w-full`}>
            {label && (
                <label className={labelClassName}>
                    {label} {isRequired && <span className="text-red-500">*</span>}
                </label>
            )}
            <select
                {...props}
                name={fieldName}
                ref={ref}
                onBlur={onBlur}
                value={value ?? ""}
                onChange={onChange}
                disabled={disabled}
                className={`${FORM_FIELD.control} ${error ? FORM_FIELD.error : ''} ${disabled ? FORM_FIELD.disabled : `${FORM_FIELD.enabled} cursor-pointer`} ${inputClassName}`}
            >
                {placeholder && <option value="">{placeholder}</option>}
                {children ? children : options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            {reserveErrorSpace ? (
                <p
                    className={`${errorClassName} min-h-[14px] leading-tight ${errorMessage ? "" : "invisible"}`}
                    aria-live="polite"
                >
                    {errorMessage || "\u00a0"}
                </p>
            ) : errorMessage ? (
                <p className={errorClassName}>{errorMessage}</p>
            ) : null}
        </div>
    );
};

EvaluationSelect.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    disabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    rules: PropTypes.object,
    reserveErrorSpace: PropTypes.bool,
    errorClassName: PropTypes.string,
    children: PropTypes.node,
};

export default EvaluationSelect;
